function getEnv(envName, defaultValue) {
  if (!window.env) {
    window.env = {};
  }

  if (window.env[envName] == null) {
    window.env[envName] = defaultValue;
  }

  return window.env[envName];
}

function parseBooleanEnv(envName, defaultValue) {
  const rawValue = String(getEnv(envName, defaultValue)).trim().toLowerCase();
  return rawValue === "true" || rawValue === "1" || rawValue === "yes";
}

const IS_LOCALHOST = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const LOCALHOST_API_DEFAULT = IS_LOCALHOST ? "http://localhost:8080" : "";
const DEFAULT_KEYCLOAK_URL = "https://keycloak.prd.rede.tst/auth";

export const PORTAL_API = getEnv("PORTAL_API", LOCALHOST_API_DEFAULT);
export const GOOGLEANALYTICS_ID = getEnv("GOOGLEANALYTICS_ID", "");
export const HOTJAR_ID = getEnv("HOTJAR_ID", "");
export const KEYCLOAK_ENABLED = parseBooleanEnv(
  "KEYCLOAK_ENABLED",
  "true"
);
export const KEYCLOAK_CHECK_LOGIN_IFRAME = parseBooleanEnv(
  "KEYCLOAK_CHECK_LOGIN_IFRAME",
  "false"
);
export const KEYCLOAK_URL = getEnv(
  "KEYCLOAK",
  DEFAULT_KEYCLOAK_URL
);
export const KEYCLOAK_REALM = getEnv("KEYCLOAK_REALM", "tst-users");
export const KEYCLOAK_CLIENT_ID = getEnv("KEYCLOAK_CLIENT_ID", "portal-app");
